import React, { PropsWithChildren } from 'react';
import { Heading } from '@highlight-ui/typography';

import styles from './OptionGroup.module.scss';

export type OptionGroupProps = PropsWithChildren<{
  /** Group title */
  name: string;
}>;

const OptionGroup = ({ name, children }: OptionGroupProps) => (
  <li className={styles.optionGroup}>
    <div className={styles.optionGroupName}>
      <Heading as="span" variant="small" color="text-default">
        {name}
      </Heading>
    </div>
    <ul>{children}</ul>
  </li>
);

export default OptionGroup;
